"use client";

import Image from "next/image";
import Link from "next/link";
import Button from "../../ui/Button";
import Breadcrumbs from "@/components/ui/Breadcrumbs";

/** Art-only PNG at `public/media/pages/dank-club/hero.webp` (Dank Club card + velvet-rope illustration). */
const DANK_CLUB_HERO_IMAGE = "/media/pages/dank-club/hero.webp";

export default function DankClubHeroSection() {
  return (
    <section className="w-full max-w-none" aria-labelledby="dank-club-hero-heading">
      <div className="w-full">
        <Breadcrumbs items={[{ label: "Dank Club" }]} />

        <div className="grid gap-8 lg:grid-cols-2 lg:items-center lg:gap-12">
          <div className="order-2 min-w-0 lg:order-1">
            <h1
              id="dank-club-hero-heading"
              className="text-h2-mobile lg:text-h2-desktop font-bold leading-tight text-text-primary"
            >
              Join the Dank Club!
            </h1>
            <p className="mt-4 text-body-16-desktop leading-relaxed text-text-secondary">
              Don&apos;t miss out on freebies and premium perks. Join the Dank Club loyalty program today
              to earn points on every purchase, unlock exclusive members-only deals, and enjoy special
              discounts tailored just for you. It&apos;s free to join—start getting rewarded for what you
              love!
            </p>
            <div className="mt-8 flex max-sm:flex-col gap-3">
              <Button asChild variant="primary" size="lg" className="rounded-xl px-6">
                <Link href="/register">Create account</Link>
              </Button>
              <Button asChild variant="bordered" color="white" size="lg" className="rounded-xl px-6">
                <Link href="/login">Sign in</Link>
              </Button>
            </div>
          </div>

          <div className="relative order-1 w-full lg:order-2">
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-2xl border border-neutral-10 bg-bg-2 shadow-sm sm:rounded-2xl">
              <Image
                src={DANK_CLUB_HERO_IMAGE}
                alt="Illustration of members joining the Dank Club loyalty program"
                fill
                className="object-cover object-center"
                sizes="(max-width: 1023px) 100vw, (max-width: 1920px) 50vw, 960px"
                quality={100}
                unoptimized
                priority
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
